import { type CSSProperties, type ReactNode } from 'react';
import { telHref, looksDialable } from '../lib/phone';
import { useI18n } from '../lib/i18n';

/**
 * Teléfono clickeable → abre la app de teléfono/softphone del usuario (RingCentral) vía `tel:`,
 * para que llame directo desde SU propio número (la cuenta graba la llamada, y el worker la baja
 * al claim después). No usa RingOut. `claimId`/`recipientType` se aceptan por compat pero se
 * ignoran (quedan disponibles por si en el futuro se reactiva el click-to-call server-side).
 */
export function PhoneLink({
  phone, children, style, className, title,
}: {
  phone: string | null | undefined;
  claimId?: string | null;
  recipientType?: string | null;
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  title?: string;
}) {
  const { t } = useI18n();
  const num = String(phone ?? '').trim();
  if (!num || !looksDialable(num)) return <>{children ?? num ?? null}</>;
  return (
    <a
      href={telHref(num)}
      onClick={(e) => e.stopPropagation()}
      className={className}
      title={title ?? t('call.title')}
      style={{ cursor: 'pointer', ...style }}
    >
      {children ?? num}
    </a>
  );
}
